import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  slug: string;
  title: string;
  year: number;
  category: string;
  rating: number;
  posterUrl: string;
  isVip?: boolean;
  isNew?: boolean;
}

export default function MovieCard({ id, slug, title, year, category, rating, posterUrl, isVip, isNew }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={posterUrl}
          alt={title}
          title={`${title} - 屁屁影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {isVip && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
              VIP
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              新
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-bold bg-background-950/70 text-accent-500 rounded-md whitespace-nowrap">
            {rating.toFixed(1)}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="text-[10px] text-background-200/80 bg-background-950/40 px-2 py-0.5 rounded-md whitespace-nowrap">
            {year} · {category}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </span>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 whitespace-nowrap">
        {title}
      </h3>
    </Link>
  );
}